import React from "react";

import { Container, Row, Col, Card } from "reactstrap";
import {
  Building2,
  Map,
  HardHat,
  TrainFront,
  Zap,
  Layers,
  Cpu,
  MapPin,
} from "lucide-react";

import "react-circular-progressbar/dist/styles.css";

const UK_PRIMARY = "#3e3f99";
const UK_SECONDARY = "#00a8c4";

function AboutPoints() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  return (
    <div className="section" style={{ backgroundColor: "transparent" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div
              style={{
                background: "#ffffff",
                borderRadius: "20px",
                border: "1px solid rgba(62,63,153,0.1)",
                boxShadow: "0 16px 40px rgba(31,36,64,0.1)",
                padding: size ? "2.25rem 2.35rem" : "1.5rem 1.25rem",
              }}
            >
              <div className="d-flex align-items-center mb-3" style={{ gap: "0.85rem" }}>
                <div
                  style={{
                    width: size ? 48 : 42,
                    height: size ? 48 : 42,
                    minWidth: size ? 48 : 42,
                    borderRadius: "12px",
                    background: `linear-gradient(145deg, ${UK_PRIMARY}18, ${UK_SECONDARY}14)`,
                    border: `1.5px solid ${UK_PRIMARY}33`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MapPin size={size ? 22 : 20} strokeWidth={2.2} style={{ color: UK_PRIMARY }} />
                </div>
                <h1
                  className="m-0 text-g-p"
                  style={{
                    fontSize: size ? "2.35rem" : "1.65rem",
                    color: UK_PRIMARY,
                    letterSpacing: "0.04em",
                  }}
                >
                  WHY BIRMINGHAM?
                </h1>
              </div>
              <div
                style={{
                  width: "88px",
                  height: "4px",
                  borderRadius: "2px",
                  marginBottom: "1.35rem",
                  background: `linear-gradient(90deg, ${UK_PRIMARY}, ${UK_SECONDARY})`,
                }}
              />
              <p
                className="mb-3"
                style={{
                  fontSize: size ? "1.08rem" : "0.98rem",
                  lineHeight: 1.7,
                  color: "#1f2440",
                  fontWeight: 500,
                  maxWidth: "740px",
                }}
              >
                Birmingham is rapidly establishing itself as one of the UK&apos;s leading innovation
                and infrastructure hubs. As the nation&apos;s second-largest city, it is investing
                significantly in digital transformation, sustainable mobility, regeneration, clean
                energy, and smart city initiatives.
              </p>
              <p
                className="mb-4"
                style={{
                  fontSize: size ? "1.02rem" : "0.95rem",
                  lineHeight: 1.7,
                  color: "#2c3355",
                  fontWeight: 500,
                  maxWidth: "740px",
                }}
              >
                With strong collaboration between local government, academia, industry, and technology
                partners, Birmingham provides the perfect environment for advancing innovation in:
              </p>

              <Row>
                {whyBirmingham.map((item) => {
                  const Icon = item.icon;
                  return (
                    <Col md={6} key={item.title} className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1rem",
                          height: "100%",
                          padding: size ? "1.05rem 1.15rem" : "0.95rem 1rem",
                          borderRadius: "14px",
                          background: "#f6f8fc",
                          border: "1px solid rgba(62,63,153,0.14)",
                        }}
                      >
                        <div
                          style={{
                            width: 46,
                            height: 46,
                            minWidth: 46,
                            borderRadius: "12px",
                            background: "#ffffff",
                            border: `1.5px solid ${UK_SECONDARY}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon size={22} strokeWidth={2.2} style={{ color: UK_PRIMARY }} />
                        </div>
                        <h5
                          className="mb-0"
                          style={{
                            fontSize: size ? "0.98rem" : "0.9rem",
                            lineHeight: 1.4,
                            color: "#1f2440",
                            fontWeight: 700,
                            letterSpacing: "0.01em",
                          }}
                        >
                          {item.title}
                        </h5>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export function ConferenceFormat() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <div
      className="section"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <Container>
        <Row>
          <Col md={12} className="pr-0">
            <h1
              className="m-0 my-4 text-g text-left"
              style={{
                fontSize: size ? "3rem" : "2rem",
              }}
            >
              Conference Format
            </h1>
          </Col>

          {conferenceFormat.map((c, i) => (
            <Col lg={6} xs={12} key={c.title}>
              <Card
                className=""
                style={{
                  background: i % 2 !== 0 ? "#00a8c4" : "#3e3f99",
                  height: size ? "90px" : "none",
                }}
              >
                <div className="d-flex p-2 align-items-center">
                  <div className="px-2 align-self-center">
                    <img
                      src={require(`assets/icons/${c.image}`)}
                      style={{ width: "70px" }}
                      width="100%"
                      alt="about"
                    />
                  </div>
                  <p className="text-400 py-2 text-white mb-0">{c.title}</p>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default AboutPoints;

const whyBirmingham = [
  {
    icon: Building2,
    title: "Smart Cities & Connected Communities",
  },
  {
    icon: Map,
    title: "Urban Planning & City Regeneration",
  },
  {
    icon: HardHat,
    title: "Built Environment & Digital Construction",
  },
  {
    icon: TrainFront,
    title: "Transportation & Intelligent Mobility",
  },
  {
    icon: Zap,
    title: "Energy Networks & Utilities",
  },
  {
    icon: Layers,
    title: "Infrastructure Asset Management",
  },
  {
    icon: Cpu,
    title: "AI, IoT, GIS, BIM & Data Integration",
  },
];

const conferenceFormat = [
  {
    title: "TECHNICAL & INTERACTIVE PRE-CONFERENCE WORKSHOPS",
    image: "Asset 10.png",
  },
  {
    title: "VISIONARY KEYNOTES",
    image: "Asset 19.png",
  },
  {
    title: "CASE STUDIES AND PROOF OF CONCEPTS",
    image: "Asset 9.png",
  },
  {
    title: "THOUGHT-PROVOKING PANEL DISCUSSIONS",
    image: "Asset 13 2.png",
  },
  {
    title: "EXHIBITION & NETWORKING",
    image: "Asset 12.png",
  },
];
